import { combineReducers } from 'redux';
import MainReducer from "./reducer_main";
import RosterReducer from "./reducer_roster";
import TeamRankingsReducer from "./reducer_teamrankings";
import TeamConsistencyReducer from "./reducer_teamconsistency";
import IndConsistencyReducer from "./reducer_indconsistency";
import MVPReducer from "./reducer_mvp";
import ImpactDiffReducer from "./reducer_impactdiff";
import TopScoresReducer from "./reducer_topscores";
import LineupFreqReducer from "./reducer_lineupfreq";
import GymnastReducer from "./reducer_gymnast";

const rootReducer = combineReducers({
  main: MainReducer,
  roster: RosterReducer,
  teamRankings: TeamRankingsReducer,
  teamConsistency: TeamConsistencyReducer,
  indConsistency: IndConsistencyReducer,
  mvp: MVPReducer,
  impactDiff: ImpactDiffReducer,
  topScores: TopScoresReducer,
  lineupFreq: LineupFreqReducer,
  gymnast: GymnastReducer
});

export default rootReducer;
